/* Orinne premium layer. Only adds behaviour theme.js does not have. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Build a money formatter from the store's own rendering of an amount ("€35", "402,61 kr"),
     so prices updated in JS match the Liquid-rendered ones. Whole amounts drop their decimals.
     \s already covers the no-break and narrow no-break spaces some locales group digits with. */
  function formatterFrom(sample, inferThousands) {
    var match = sample && sample.match(/\d[\d.,\s']*\d|\d/);
    if (!match) return null;
    var num = match[0];
    var pre = sample.slice(0, match.index);
    var post = sample.slice(match.index + num.length);
    var hasDecimals = /[.,]\d{2}$/.test(num);
    var intPart = hasDecimals ? num.slice(0, -3) : num;
    var thou = (intPart.match(/[^\d]/) || [''])[0];
    var dec = hasDecimals ? num.charAt(num.length - 3) : (thou === ',' ? '.' : ',');
    /* a sample under 1000 shows no grouping; Shopify groups with the opposite of the decimal mark */
    if (!thou && inferThousands) thou = dec === ',' ? '.' : ',';
    return function (cents) {
      var whole = cents % 100 === 0;
      var parts = (cents / 100).toFixed(whole ? 0 : 2).split('.');
      var i = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return pre + i + (whole ? '' : dec + parts[1]) + post;
    };
  }

  /* "€22,00" -> "€22", "287,00 kr" -> "287 kr"; real decimals are left alone. */
  function stripZeros(text) {
    return String(text).replace(/([.,])00(?=[^\d]*$)/, '');
  }

  ready(function () {

    /* ---------- delivery estimate (business days, weekends skipped) ---------- */
    function addBusinessDays(date, n) {
      var d = new Date(date.getTime());
      var left = n;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) left--;
      }
      return d;
    }

    $$('[data-pp-delivery]').forEach(function (el) {
      var n = function (k) { return parseInt(el.getAttribute('data-' + k), 10) || 0; };
      var today = new Date();
      var from = addBusinessDays(today, n('dispatch-min') + n('transit-min'));
      var to = addBusinessDays(today, n('dispatch-max') + n('transit-max'));
      var locale = el.getAttribute('data-locale') || undefined;
      var fmt;
      try { fmt = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }); }
      catch (e) { fmt = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' }); }
      var base = el.textContent.trim();
      var prefix = el.getAttribute('data-prefix') || '';
      el.textContent = '';
      var a = document.createElement('span');
      a.textContent = base;
      var b = document.createElement('span');
      b.className = 'pp__estimate';
      b.textContent = prefix + ' ' + fmt.format(from) + ' – ' + fmt.format(to);
      el.appendChild(a);
      el.appendChild(b);
    });

    /* ---------- product price display ---------- */
    var priceEl = $('.pp [data-price]');
    var storeFormat = priceEl ? formatterFrom(priceEl.textContent.trim()) : null;
    var money = function (cents) { return storeFormat ? storeFormat(cents) : (cents / 100).toFixed(2); };

    /* theme.js re-renders the price with decimals on variant change; put the clean format back */
    document.addEventListener('lumen:variant', function (e) {
      if (priceEl && e.detail && typeof e.detail.price === 'number') priceEl.textContent = money(e.detail.price);
    });

    /* ---------- two-of offer ---------- */
    var bundle = $('[data-pp-bundle]');
    if (bundle) {
      var form = bundle.closest('form');
      var pct = parseFloat(bundle.getAttribute('data-pct'));
      if (!(pct > 0 && pct < 100)) pct = 0;
      /* Same as Shopify at checkout: the discount on each line is rounded down to the cent. */
      var afterDiscount = function (cents) { return cents - Math.floor(cents * pct / 100 + 1e-6); };
      var second = $('[data-pp-second]', bundle);
      var secondOut = $('[data-pp-second-out]', bundle);
      var hint = $('[data-pp-hint]', bundle);
      var check = $('[data-pair-check]', bundle);
      var onePrice = $('[data-pp-one]', bundle);
      var twoPrice = $('[data-pp-two]', bundle);
      var saveEl = $('[data-pp-save]', bundle);
      var badgeTpl = saveEl ? (saveEl.getAttribute('data-template') || '') : '';
      var atc = form && $('[data-atc]', form);
      var mode = 1;

      var variants = [];
      try { variants = JSON.parse($('[data-variant-json]').textContent); } catch (e) {}
      var currentId = function () { var i = form && form.querySelector('[name="id"]'); return i ? parseInt(i.value, 10) : null; };
      var priceOf = function (id) {
        for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i].price;
        return 0;
      };

      var refresh = function () {
        var first = priceOf(currentId());
        var secondId = check.value ? parseInt(check.value, 10) : null;
        var secondPrice = secondId ? priceOf(secondId) : first;
        var full = first + secondPrice;
        var pair = afterDiscount(first) + afterDiscount(secondPrice);
        if (onePrice) onePrice.textContent = money(first);
        if (twoPrice) twoPrice.textContent = money(pair);
        if (saveEl && badgeTpl) saveEl.textContent = badgeTpl.replace('[save]', money(full - pair));
        if (atc && atc.getAttribute('data-label') && !atc.classList.contains('is-disabled') && !atc.disabled) {
          var label = atc.getAttribute('data-label');
          atc.textContent = mode === 2 ? label + ' · ' + money(pair) : label;
        }
      };

      bundle.addEventListener('change', function (e) {
        var r = e.target.closest('input[name="pp-qty"]');
        if (!r) return;
        mode = parseInt(r.value, 10);
        $$('.pp__tier', bundle).forEach(function (t) { t.classList.toggle('is-on', t.contains(r)); });
        second.hidden = mode !== 2;
        check.checked = mode === 2 && !!check.value;
        if (form) form.classList.toggle('has-pairs', check.checked);
        if (hint) hint.hidden = true;
        refresh();
      });

      bundle.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pp-letter]');
        if (!b || b.disabled) return;
        $$('[data-pp-letter]', bundle).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        check.value = b.getAttribute('data-pp-letter');
        check.checked = mode === 2;
        if (secondOut) secondOut.textContent = b.textContent.trim();
        if (hint) hint.hidden = true;
        if (form) form.classList.toggle('has-pairs', check.checked);
        refresh();
      });

      document.addEventListener('lumen:variant', function () { setTimeout(refresh, 0); });

      /* capture phase: runs before theme.js's own submit handler on the form */
      document.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (mode === 2 && !check.value) {
          e.preventDefault();
          e.stopPropagation();
          if (hint) hint.hidden = false;
          second.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    /* ---------- pair picker: a colour for every pair ----------
       Each colour is its own variant. On submit the pairs are grouped by colour and added as
       separate lines through theme.js's add-to-cart, so the supplier gets exact quantities.
       Prices follow Shopify: the percentage is taken off each line and rounded down. */
    var picker = $('[data-pp-picker]');
    if (picker) {
      var pForm = picker.closest('form');
      var pAtc = pForm && $('[data-atc]', pForm);
      var pVariants = [];
      try { pVariants = JSON.parse($('[data-variant-json]').textContent); } catch (e) {}
      var byId = {};
      pVariants.forEach(function (x) { byId[x.id] = x; });
      var firstAvail = pVariants.filter(function (x) { return x.available; })[0] || pVariants[0];
      var slotsEl = $('[data-pp-slots]', picker);
      var countEl = $('[data-pp-count]', picker);
      var summaryEl = $('[data-pp-summary]', picker);
      var sameBtn = $('[data-pp-same]', picker);
      var slotWord = picker.getAttribute('data-slot-label') || 'Pair';
      var picked = $('input[name="pp-pairs"]:checked', picker);
      var pairs = picked ? parseInt(picked.value, 10) || 1 : 1;
      var pPct = picked ? parseFloat(picked.getAttribute('data-pct')) || 0 : 0;
      var idInput = pForm && pForm.querySelector('[name="id"]');
      var startId = idInput && byId[parseInt(idInput.value, 10)] && byId[parseInt(idInput.value, 10)].available
        ? parseInt(idInput.value, 10) : (firstAvail ? firstAvail.id : null);
      var slots = [];
      for (var s = 0; s < pairs; s++) slots.push(startId);
      var active = 0;
      /* the colour last tapped (or the pair last selected) is what "same colour for every pair" copies */
      var lastColour = null;

      var hexOf = function (id) {
        var b = $('[data-pp-swatch="' + id + '"]', picker);
        return b ? b.style.getPropertyValue('--sw').trim() : '';
      };
      var nameOf = function (id) { return byId[id] ? byId[id].title : ''; };
      var groups = function () {
        var order = [], qty = {};
        slots.forEach(function (id) { if (!qty[id]) { qty[id] = 0; order.push(id); } qty[id]++; });
        return order.map(function (id) { return { id: id, quantity: qty[id] }; });
      };
      var totalOf = function (list) {
        return list.reduce(function (sum, g) {
          var line = (byId[g.id] ? byId[g.id].price : 0) * g.quantity;
          return sum + line - Math.floor(line * pPct / 100 + 1e-6);
        }, 0);
      };

      var render = function () {
        slotsEl.innerHTML = '';
        slots.forEach(function (id, i) {
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pp-slot' + (i === active ? ' is-active' : '');
          b.setAttribute('data-pp-slot', String(i));
          b.setAttribute('aria-pressed', i === active ? 'true' : 'false');
          b.setAttribute('aria-label', slotWord + ' ' + (i + 1) + ': ' + nameOf(id));
          var num = document.createElement('span');
          num.className = 'pp-slot__n';
          num.setAttribute('aria-hidden', 'true');
          num.textContent = String(i + 1);
          var dot = document.createElement('span');
          dot.className = 'pp-slot__dot';
          dot.setAttribute('aria-hidden', 'true');
          dot.style.setProperty('--sw', hexOf(id));
          b.appendChild(num);
          b.appendChild(dot);
          li.appendChild(b);
          slotsEl.appendChild(li);
        });
        $$('[data-pp-swatch]', picker).forEach(function (b) {
          var on = parseInt(b.getAttribute('data-pp-swatch'), 10) === slots[active];
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var list = groups();
        var total = totalOf(list);
        if (countEl) countEl.textContent = slotWord + ' ' + (active + 1) + ' of ' + pairs;
        if (summaryEl) summaryEl.textContent = list.map(function (g) { return nameOf(g.id) + ' × ' + g.quantity; }).join(' · ');
        if (sameBtn) sameBtn.hidden = pairs < 2;
        if (priceEl) priceEl.textContent = money(total);
        if (pAtc && !pAtc.disabled && pAtc.getAttribute('data-label')) {
          pAtc.textContent = pAtc.getAttribute('data-label') + ' · ' + money(total);
        }
      };

      picker.addEventListener('change', function (e) {
        var r = e.target.closest('input[name="pp-pairs"]');
        if (!r) return;
        $$('.pp__tier', picker).forEach(function (t) { t.classList.toggle('is-on', t.contains(r)); });
        var next = parseInt(r.value, 10) || 1;
        pPct = parseFloat(r.getAttribute('data-pct')) || 0;
        var fill = slots[slots.length - 1] || startId;
        while (slots.length < next) slots.push(fill);
        slots.length = next;
        pairs = next;
        if (active > pairs - 1) active = pairs - 1;
        render();
      });

      picker.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-pp-swatch]');
        if (sw) {
          if (sw.disabled) return;
          var id = parseInt(sw.getAttribute('data-pp-swatch'), 10);
          slots[active] = id;
          lastColour = id;
          if (byId[id] && byId[id].featured_media && window.lumenGallery) window.lumenGallery(byId[id].featured_media.id);
          if (active < pairs - 1) active++;
          render();
          return;
        }
        var sl = e.target.closest('[data-pp-slot]');
        if (sl) {
          active = parseInt(sl.getAttribute('data-pp-slot'), 10) || 0;
          lastColour = slots[active];
          render();
          var again = $('[data-pp-slot="' + active + '"]', picker);
          if (again) again.focus();
          return;
        }
        if (e.target.closest('[data-pp-same]')) {
          var colour = lastColour || slots[active];
          slots = slots.map(function () { return colour; });
          render();
        }
      });

      /* capture phase: runs before theme.js's single-variant submit handler on the form */
      document.addEventListener('submit', function (e) {
        if (e.target !== pForm) return;
        e.preventDefault();
        e.stopPropagation();
        var list = groups();
        if (!list.length || !window.lumenAdd) return;
        window.lumenAdd(String(list[0].id), list[0].quantity, pAtc, list.slice(1).map(function (g) {
          return { id: g.id, quantity: g.quantity };
        }));
      }, true);

      render();
    }

    /* ---------- cart drawer add-on: pick an option without leaving the cart ----------
       theme.js only offers a "Choose" link for products with options. Swap that link for
       a small option select + Add button that uses theme.js's own add-to-cart. */
    var slot = document.getElementById('drawer-upsell-slot');
    if (slot && window.MutationObserver) {
      var pending = null;
      var enhance = function () {
        var price = slot.querySelector('.upsell__price');
        if (price && !price.hasAttribute('data-pp-clean')) {
          price.setAttribute('data-pp-clean', '');
          price.textContent = stripZeros(price.textContent);
        }
        var link = slot.querySelector('a.upsell__add');
        if (!link) return;
        var m = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (!m || pending === m[1]) return;
        pending = m[1];
        fetch('/products/' + m[1] + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            pending = null;
            if (!slot.contains(link)) return;
            var avail = (p.variants || []).filter(function (v) { return v.available; });
            if (!avail.length) return;
            var wrap = document.createElement('div');
            wrap.className = 'upsell__pick';
            var select = null;
            if (avail.length > 1) {
              select = document.createElement('select');
              select.className = 'upsell__select';
              var opt0 = p.options && p.options[0];
              select.setAttribute('aria-label', (opt0 && (opt0.name || opt0)) || 'Option');
              avail.forEach(function (v) {
                var o = document.createElement('option');
                o.value = v.id;
                o.textContent = v.title;
                select.appendChild(o);
              });
              wrap.appendChild(select);
            }
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'upsell__add';
            btn.textContent = (window.Lumen && window.Lumen.strings && window.Lumen.strings.add) || 'Add';
            btn.addEventListener('click', function () {
              var id = select ? select.value : avail[0].id;
              if (window.lumenAdd) window.lumenAdd(String(id), 1, btn);
            });
            wrap.appendChild(btn);
            link.parentNode.replaceChild(wrap, link);
          })
          .catch(function () { pending = null; });
      };
      new MutationObserver(enhance).observe(slot, { childList: true, subtree: true });
      enhance();
    }

    /* ---------- cart drawer amounts in the store's own format ----------
       theme.js writes drawer amounts with Intl in English ("SEK 243.60"), which is wider than the
       store's "243,60 kr" and runs off narrow phones. Rewrite them in the format of a Liquid-rendered
       price (the add-on list), reading each amount back from the text theme.js wrote. */
    var upsellData = document.querySelector('[data-upsell-json]');
    var drawerRoot = document.getElementById('cart-drawer');
    var drawerFmt = null;
    if (upsellData) {
      try {
        var upsellList = JSON.parse(upsellData.textContent);
        if (upsellList[0] && upsellList[0].price) drawerFmt = formatterFrom(String(upsellList[0].price), true);
      } catch (e) {}
    }
    if (drawerFmt && drawerRoot && window.MutationObserver) {
      var centsFrom = function (text) {
        var digits = String(text).replace(/[^\d.,]/g, '');
        if (!/\d/.test(digits)) return null;
        var m = digits.match(/^(.*?)(?:[.,](\d{2}))?$/);
        return parseInt(m[1].replace(/[.,]/g, '') || '0', 10) * 100 + parseInt(m[2] || '0', 10);
      };
      var fixAmount = function (el) {
        if (!el || el.getAttribute('data-pp-fmt') === el.textContent) return;
        var cents = centsFrom(el.textContent);
        if (cents === null) return;
        el.textContent = drawerFmt(cents);
        el.setAttribute('data-pp-fmt', el.textContent);
      };
      var fixDrawer = function () {
        $$('.ditem__price', drawerRoot).forEach(fixAmount);
        fixAmount(document.getElementById('drawer-total'));
        fixAmount(document.querySelector('#ship-label strong'));
      };
      new MutationObserver(fixDrawer).observe(drawerRoot, { childList: true, subtree: true, characterData: true });
      fixDrawer();
    }

    /* ---------- "or two for …" under the price: selects the pair option ---------- */
    var pairNote = $('[data-pp-pairnote]');
    if (pairNote && bundle) {
      pairNote.addEventListener('click', function () {
        var two = $('input[name="pp-qty"][value="2"]', bundle);
        if (!two) return;
        two.checked = true;
        two.dispatchEvent(new Event('change', { bubbles: true }));
        ($('[data-pp-second]', bundle) || bundle).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    /* ---------- suggested with this product ----------
       Adds the one suggested product through theme.js's add-to-cart. A product with options has to be
       chosen from the list first; the price follows the chosen option. */
    $$('[data-pp-sug]').forEach(function (box) {
      var sel = $('[data-pp-sug-select]', box);
      var add = $('[data-pp-sug-add]', box);
      var price = $('[data-pp-sug-price]', box);
      var hint = $('[data-pp-sug-hint]', box);
      if (sel) {
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          if (o && o.getAttribute('data-price') && price) price.textContent = o.getAttribute('data-price');
          box.classList.remove('needs-choice');
          if (hint) hint.hidden = true;
        });
      }
      add.addEventListener('click', function () {
        var id = sel ? sel.value : add.getAttribute('data-id');
        if (!id) {
          box.classList.add('needs-choice');
          if (hint) hint.hidden = false;
          if (sel) sel.focus();
          return;
        }
        if (window.lumenAdd) window.lumenAdd(String(id), 1, add);
      });
    });

    /* ---------- phone buy bar ----------
       Slides up once the real Add to bag has scrolled off the top. Until the shopper has chosen
       something it scrolls back to the options, so nobody gets a default initial or colour they never
       picked. After that it presses the real button, so the pair offer and pair picker apply unchanged. */
    var bar = $('[data-pp-bar]');
    var barForm = $('.pp form[data-product-form]');
    var barAtc = barForm && $('[data-atc]', barForm);
    if (bar && barAtc) {
      var barBtn = $('[data-pp-bar-btn]', bar);
      var barSel = $('[data-pp-bar-sel]', bar);
      var footer = $('.site-footer');
      var phone = window.matchMedia('(max-width: 989px)');
      var touched = bar.getAttribute('data-needs-choice') !== 'true' || /[?&]variant=/.test(location.search);
      var firstOpt = $('.pp__opt', barForm) || $('[data-pp-picker]', barForm);
      var optName = '';
      if (firstOpt && firstOpt.classList.contains('pp__opt')) {
        var optLabel = $('.pp__label', firstOpt);
        optName = optLabel && optLabel.firstChild ? optLabel.firstChild.textContent.trim().toLowerCase() : '';
        if (optName === 'color') optName = 'colour';
      }
      var chooseText = (bar.getAttribute('data-choose') || 'Choose').replace('[option]', optName).trim();

      var selection = function () {
        var summary = $('[data-pp-summary]', barForm);
        if (summary) return summary.textContent.trim();
        var text = $$('.pp__opt', barForm).map(function (o) {
          var out = $('[data-opt-out]', o);
          return out ? out.textContent.trim() : '';
        }).filter(Boolean).join(' / ');
        var two = $('input[name="pp-qty"][value="2"]', barForm);
        var second = $('[data-pp-second-out]', barForm);
        if (two && two.checked && second && /\w/.test(second.textContent)) text += ' + ' + second.textContent.trim();
        return text;
      };

      var syncBar = function () {
        var price = priceEl ? priceEl.textContent.trim() : '';
        if (!touched) {
          barSel.textContent = price;
          barBtn.textContent = chooseText;
          barBtn.disabled = false;
          return;
        }
        barSel.textContent = selection() || price;
        var off = barAtc.disabled || barAtc.classList.contains('is-disabled');
        var label = barAtc.textContent.trim();
        if (!off && label.indexOf('·') === -1 && price) label += ' · ' + price;
        barBtn.textContent = label;
        barBtn.disabled = off;
      };

      var markTouched = function () { touched = true; syncBar(); };
      barForm.addEventListener('click', function (e) {
        if (e.target.closest('.opt__val, [data-pp-swatch], [data-pp-slot], [data-pp-same], [data-pp-letter]')) markTouched();
      });
      barForm.addEventListener('change', function (e) {
        if (e.target.closest('input[name="pp-pairs"]')) markTouched();
      });
      if (window.MutationObserver) {
        var watch = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'checked'] };
        new MutationObserver(syncBar).observe(barForm, watch);
        if (priceEl) new MutationObserver(syncBar).observe(priceEl, watch);
      }

      var shown = false;
      var ticking = false;
      var place = function () {
        ticking = false;
        var on = phone.matches && barAtc.getBoundingClientRect().bottom < 0 &&
          !(footer && footer.getBoundingClientRect().top < window.innerHeight);
        if (on === shown) return;
        shown = on;
        bar.classList.toggle('is-on', on);
        document.body.classList.toggle('pp-bar-on', on);
        bar.inert = !on;
      };
      var onScroll = function () { if (!ticking) { ticking = true; requestAnimationFrame(place); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      barBtn.addEventListener('click', function () {
        if (!touched) {
          (firstOpt || barForm).scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (!barBtn.disabled) barAtc.click();
      });

      bar.inert = true;
      bar.hidden = false;
      syncBar();
      place();
    }

    /* ---------- gentle reveal on scroll ---------- */
    var fades = $$('.pp-fade');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      fades.forEach(function (el) { io.observe(el); });
    } else {
      fades.forEach(function (el) { el.classList.add('is-in'); });
    }
  });
})();